import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from '../../service/global-error-handler.service';

import { Healthgroup } from '../../healthgroup/healthgroup';
import { Clinic } from '../../clinic/clinic';
import { HealthgroupService } from '../../service/healthgroup.service';

@Component({
  selector: 'mc-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent {

  signInUser = { login: '', password: '' };
  userClinics: Clinic[];
  selectedClinic: Clinic;
  selectClinicDisabled: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private notifService: ToastrService,
    private errorHandler: GlobalErrorHandlerService,
    private hgroupService: HealthgroupService
  ) { }

  getUserClinics(): void {
    this.hgroupService.findClinicByUserName(this.signInUser.login)
      .pipe(catchError((error) => this.errorHandler.handleError(error)))
      .subscribe(user => {
        this.userClinics = user.clinics;
        if (user.clinics.length > 0) {
          this.selectedClinic = this.userClinics[0];
        }
      });
  }

  signingIn() {
    this.authService.signIn(this.signInUser, this.selectedClinic).subscribe(
      res => {
        this.router.navigate(['home']);
      },
      err => {
        this.notifService.error(err);
      }
    );
  }
}
